import NiceModal, { register, useModal } from "@ebay/nice-modal-react";
import { Dialog, DialogActions, Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { useTypedTranslation } from "@repo/ui";
import React, { ReactNode, useCallback } from "react";

import { DummyComponent } from "../MuiHelpers";
import * as Styled from "./ModalSlideUp.styled";
import { Modals } from "./modals";

type ModalSlideUpProps = {
    title: string | ReactNode;
    content: ReactNode;
    buttonText?: string;
    width?: number;
};

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const ModalSlideUp = NiceModal.create<ModalSlideUpProps>(({ title, content, buttonText, width = 480 }) => {
    const modal = useModal();
    const { t } = useTypedTranslation();

    const handleButton = useCallback(() => {
        modal.resolve(true);
        modal.hide();
    }, []);

    const closeButton = useCallback(() => {
        modal.hide();
    }, []);

    return (
        <Dialog
            // we have to use a dummy component here because MUI Dialog requires a PaperComponent prop,
            // if notprovided it use Paper and it has a global style (see theme.js) that we don't want to use
            PaperComponent={DummyComponent}
            TransitionComponent={Transition}
            open={modal.visible}
            onClose={() => {
                modal.resolve(false);
                modal.hide();
            }}
            sx={{
                "& .MuiDialog-container": {
                    alignItems: "end",
                },
            }}
        >
            <Styled.ModalPaper $width={width}>
                <Styled.ModalDialogTitleStack>
                    <Styled.ModalDialogTitleText>{title}</Styled.ModalDialogTitleText>
                    <Styled.ModalCloseButton onClick={closeButton} />
                </Styled.ModalDialogTitleStack>
                <Styled.ModalDialogContent>{content}</Styled.ModalDialogContent>
                <DialogActions>
                    <Styled.ModalButton component="button" onClick={handleButton}>
                        {buttonText ?? t("global.iUnderstand")}
                    </Styled.ModalButton>
                </DialogActions>
            </Styled.ModalPaper>
        </Dialog>
    );
});

register(Modals.ModalSlideUp, ModalSlideUp);
